import { render, staticRenderFns } from "./termsandCondition.vue?vue&type=template&id=7603fddf&scoped=true"
import script from "./termsandCondition.vue?vue&type=script&lang=js"
export * from "./termsandCondition.vue?vue&type=script&lang=js"
import style0 from "./termsandCondition.vue?vue&type=style&index=0&id=7603fddf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7603fddf",
  null
  
)

export default component.exports